exports.LANGUAGES_SUPPORTED = Object.freeze({
    EN: "en",
    DA: "da",
});
